import React, { FC } from 'react';
import cx from 'classnames';
import Typo from '../Typography/Typo';

type TTerritoryTabListItemProps = {
  children: React.ReactNode;
  activeTab: boolean;
};

export const TerritoryTab: FC<TTerritoryTabListItemProps> = ({ children, activeTab }) => (
  <Typo
    variant="article-p"
    className={cx(
      'text-[22px] md:!text-[28px] text-t2-neutral-grey05 hover:text-t2-primary-brandColor !font-semibold',
      {
        'text-t2-neutral-grey08 ': activeTab,
      },
    )}
  >
    {children}
  </Typo>
);
